import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Password } from 'primeng/password';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  standalone: true,
  imports: [
    Password,
    ReactiveFormsModule,
  ]
})
export class PasswordInputComponent implements OnInit {
  /**
   * The control for the password input.
   */
  @Input() control: UntypedFormControl = new UntypedFormControl();

  /**
   * The text to show in the form field.
   */
  @Input() label = '';

  /**
   * The text to show in the form field when no value has been entered.
   */
  @Input() placeholder = '******';

  /**
   * The text to show below the form field.
   */
  @Input() hint?: string;

  /**
   * Function to run whenever a key is pressed. Defaults to nothing.
   */
  @Input() keyupHandler: Function = () => { };

  constructor() { }

  ngOnInit(): void { }

  get hasHint(): boolean {
    return this.hint != null && this.hint != '';
  }
}
